import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { BoxesCadastroComponent } from './boxes-cadastro/boxes-cadastro.component';
import { BoxesFiltroComponent } from './boxes-filtro/boxes-filtro.component';
import { BoxesListaComponent } from './boxes-lista/boxes-lista.component';
import { BoxesService } from './boxes-service/boxes.service';
import { BoxesComponent } from './boxes.component';
import { FileUploadModule } from './../../../shared/fileupload/fileupload';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS),
    FileUploadModule
  ],
  exports: [
    BoxesComponent
  ],
  declarations: [
    BoxesComponent,
    BoxesCadastroComponent,
    BoxesFiltroComponent,
    BoxesListaComponent
  ],
  providers: [
    BoxesService
  ]
})
export class BoxesModule { }
